
/**
 * Crée un DOM element a partir d'un array d'object
 * @param {object} data
 */
export function createAllBlock(data){

    let html = '';
    $.each(data, function(index, object){
        
        // verifie le type de chaque element et crée le block html correspondant
        /*
        if(object.type === 'twitter'){
            html += createtwitterBlock(object);
        }*/

        if(object.type === 'facebook'){
            html += createFacebookBlock(object);
        }
    });

    return $(html);
}

/** Crée le block facebook */
function createFacebookBlock(post)
{   
    let html = `<div class="flexmasonry-item">
                    <div class="socialWall-item socialWall-facebook">
                        <a href="${post.url}" target="_blank">
                        ${post.thumbnail && post.pageName ? `
                            <div class="socialWall-image">
                                <figure>
                                    <img src="${post.thumbnail}" alt="${post.pageName}" />
                                </figure>
                            </div>
                        ` : ''}
                        <div class="socialWall-contenu">
                            <div class="socialWall-header">
                                <i class="fa fa-facebook"></i>
                                <div>
                                    <span class="tag">@${post.pageName}</span>
                                    <div class="socialWall-date">${post.date}</div>
                                </div>
                            </div>
                            <p>${post.description}</p>
                        </div>
                    </a>
                </div>
            </div>`
    return html;
}

/*
export function createtwitterBlock(post)
{
    let html =  `<div class="flexmasonry-item">
                    <div class="socialWall-item socialWall-twitter">
                        <a href="${post.url}" target="_blank">
                            <div class="socialWall-contenu">
                                <div class="socialWall-header">
                                    <i class="fa fa-twitter"></i>
                                    <div>
                                        <span class="tag">@${post.screenName}</span>
                                        <div class="socialWall-date">${post.date}</div>
                                    </div>
                                </div>
                                <p>${post.message.replace(/<[^>]*>/g, '')}</p>
                            </div>
                        </a>
                    </div>
                </div>`
    return html;
}*/

/** Masque le loader du DOM */
export function switchLoading()
{
    $("#chargement").removeClass('active');
}

/**
 * @param string text
 * @return string
 */
export function getErreurBlock(text)
{
    return `<div class="container alert alert-danger" role="alert">
                ${text}
            </div>`
}

export function createFacebookBlockHome(post)
{
    let html = `<div class="socialWall-item socialWall-facebook">
                    <a href="${post.url}" target="_blank">
                    ${post.thumbnail && post.pageName ? `
                        <div class="socialWall-image">
                            <figure>
                                <img src="${post.thumbnail}" alt="${post.pageName}" />
                            </figure>
                        </div>
                    ` : ''}
                    <div class="socialWall-contenu">
                        <div class="socialWall-header">
                            <i class="fa fa-facebook"></i>
                            <div>
                                <span class="tag">@${post.pageName}</span>
                                <div class="socialWall-date">${post.date}</div>
                            </div>
                        </div>
                        <p>${post.description}</p>
                    </div>
                </a>
            </div>`
    return html;
}

/** Crée le block de Twitter */
/*
export function createTwitterBlockHome(post)
{
    let html =  `<div class="col-lg-6">
                    <div class="socialWall-item socialWall-twitter">
                        <a href="${post.url}" target="_blank">
                            <div class="socialWall-contenu">
                                <div class="socialWall-header">
                                    <i class="fa fa-twitter"></i>
                                    <div>
                                        <span class="tag">@${post.screenName}</span>
                                        <div class="socialWall-date">${post.date}</div>
                                    </div>
                                </div>
                                <p>${post.message.replace(/<[^>]*>/g, '')}</p>
                            </div>
                        </a>
                    </div>
                </div>`
    return html;
}*/